import React from 'react';
import { IChildrenProp, IDiv } from 'types/components/components.interface';
import './ContainerContent.scss';

interface IContainerContentProps extends IChildrenProp, IDiv {}

const ContainerContent = ({
  children,
  className = '',
  ...props
}: IContainerContentProps) => {
  return (
    <div {...props} className={`container-content ${className}`}>
      {children}
    </div>
  );
};

export default ContainerContent;
